// extracted by mini-css-extract-plugin
module.exports = {"button":"numberSelect_button__1qt4H","input":"numberSelect_input__hEO-g","wrapper":"numberSelect_wrapper__l66Jw","error":"numberSelect_error__CZaPs"};